import { NamedError } from "../../utils/Errors";

export class OneNotePageError extends NamedError<OneNotePageErrors> {
}

export enum OneNotePageErrors {
    OneNotePageNotFound = 'OneNotePageNotFound'
}